import React from "react";
import _ from "lodash";

import SyncWarnPopup from "./components/SyncWarningPopup";
import SyncPopup from "./components/SyncPopup";
import {useAssetsLiabilitiesSyncData} from "../../hooks/useAssetsLiabilitiesSyncData";
import {ASSETS_LIABILITIES_ACTIONS} from "../../../constants";

export default (props) => {
  const {
    customerId,
    flagName,
    onUpdate,
    warnPopupTitle,
    syncPopupTitle,
    syncPopupDescription,
    syncPopupNoItemsDescription,
    questionUID,
    itemSingleLabel,
    itemPluralLabel,
    children,
    syncIncompleteTitle,
    syncIncompleteDescription,
  } = props;

  const [showSyncWarnPopup, setShowSyncWarnPopup] = React.useState(false);
  const [showSyncPopup, setShowSyncPopup] = React.useState(false);
  const handleUpdate = React.useCallback(
    (items) => onUpdate(ASSETS_LIABILITIES_ACTIONS.BULK_CREATE, undefined, items), [onUpdate]);
  const [customerSyncData, setSynced] = useAssetsLiabilitiesSyncData(customerId, flagName, handleUpdate);

  React.useEffect(() => {
    const syncData = _.get(customerSyncData, 'data');
    if(syncData && !syncData[flagName] && syncData.risk_profile){
      setShowSyncWarnPopup(true);
    }
  }, [customerSyncData.updatedAt]);

  const handleClose = () => setShowSyncWarnPopup(false);
  const handleYesClick = () => {
    setShowSyncPopup(true);
    handleClose();
  };

  return (
    <>
      <SyncWarnPopup
        open={showSyncWarnPopup}
        title={warnPopupTitle}
        handleClose={handleClose}
        setSynced={setSynced}
        handleYesClick={handleYesClick}
      >
        {children}
      </SyncWarnPopup>
      {!!showSyncPopup && (
        <SyncPopup
          open
          customerId={customerId}
          title={syncPopupTitle}
          description={syncPopupDescription}
          noItemsDescription={syncPopupNoItemsDescription}
          itemSingleLabel={itemSingleLabel}
          itemPluralLabel={itemPluralLabel}
          sessionID={_.get(customerSyncData, 'data.risk_profile.session_id')}
          questionUID={questionUID}
          setSynced={setSynced}
          handleClose={() => setShowSyncPopup(false)}
          syncIncompleteTitle={syncIncompleteTitle}
          syncIncompleteDescription={syncIncompleteDescription}
        />
      )}
    </>
  )
};